module.exports = __webpack_public_path__ + "img/58.60d68984.svg";